import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

export const RhombusesFill: React.FC<SvgIconProps> = ({ ...props }) => (
  <SvgIcon {...props}>
    <path d="M6.41.518a.833.833 0 011.18 0l5.892 5.893a.833.833 0 010 1.178l-5.893 5.893a.833.833 0 01-1.178 0L.518 7.589a.833.833 0 010-1.178L6.411.518z" />
  </SvgIcon>
);
export default RhombusesFill;
